import { useNavigate, useParams } from "react-router-dom";
import { api, getAuth, clearAuth } from "@/lib/api";
import { useVerifiedSession } from "@/lib/useVerifiedSession";
import AdminShell from "@/components/AdminShell";
import { LayoutGrid, CalendarCheck } from "lucide-react";

export default function SellerLayout() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { status, data, retry } = useVerifiedSession(
    async () => {
      const auth = getAuth();
      // The signed-in seller must belong to the tenant in the URL.
      if (!auth || auth.user.role !== "seller" || auth.user.tenant_slug !== slug) return false;
      return (await api.get("/seller/me")).data;
    },
    () => nav(`/t/${slug}/seller/login`, { replace: true }),
    slug,
  );
  const seller = data?.seller;

  const logout = () => { clearAuth(); nav(`/t/${slug}/seller/login`); };

  const items = [
    { to: `/t/${slug}/seller`, icon: LayoutGrid, label: "Dashboard", end: true },
    { to: `/t/${slug}/seller/bookings`, icon: CalendarCheck, label: "Bookings" },
  ].map((n) => ({ ...n, testid: `seller-nav-${n.label.toLowerCase()}` }));

  return (
    <AdminShell testid="seller-layout" overline="Seller portal" title={seller?.business_name || "..."}
      subtitle={seller && (
        <div className="text-[11px] text-neutral-500 mt-1">★ {seller.rating?.toFixed(1)} · {seller.total_jobs} jobs</div>
      )}
      nav={items} onLogout={logout} logoutTestid="seller-logout" status={status} onRetry={retry} />
  );
}
